<template>
  <div id="app">
    <router-view/>
    <Top/>
    <!-- pc端 -->
    <div class="tool" v-if="!flag">
      <!-- <div style="width: 78px;height:78px;background-color: #e54451;border-radius: 7px;display: flex;align-items: center;justify-content: center;cursor: pointer;"> -->
        <el-popover
          placement="left"
          width="280"
          trigger="hover">
          <div style="margin-top: 1.5px;font-size: 19px;display: flex;align-items: center;"><div style="width: 25px;height: 25px;background-color: #b8b8b8;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-right: 10px;"><i style="color: #fff;font-size: 15px;" class="el-icon-phone"></i></div><div>客服电话：17762272502</div></div>
          <div slot="reference" style="width: 78px;height:78px;background-color: #e54451;border-radius: 7px;display: flex;align-items: center;justify-content: center;cursor: pointer;">
            <img style="width: 60%;" src="./assets/image/telephone.png" alt="">
          </div>
        </el-popover>
      <!-- </div> -->
      <!-- <div style="width: 78px;height:78px;background-color: #e54451;border-radius: 7px;display: flex;align-items: center;justify-content: center;margin-top: 10px;cursor: pointer;position: relative;"> -->
        <!-- <el-popover
          placement="left"
          width="200"
          trigger="hover">
          <img class="QRcode" src="./assets/image/QRcode.png" alt="">
          <div slot="reference" style="width: 78px;height:78px;background-color: #e54451;border-radius: 7px;display: flex;align-items: center;justify-content: center;margin-top: 10px;cursor: pointer;position: relative;">
            <img style="width: 60%;" src="./assets/image/scanit.png" alt="">
          </div>
        </el-popover> -->
      <!-- </div> -->
    </div>
    <!-- 移动端 -->
    <!-- <a href="tel:17762272502" v-if="flag" :class="(animationFlag ? 'animate__animated animate__slideInRight ' : 'actionsclass ') + 'mtool-box'">
      <a href="tel:17762272502" class="mtool">
        <i style="color: #fff;" :class="(flags ?'animate__animated animate__rubberBand ' : '') + 'el-icon-phone'"></i>
      </a>
      <div class="mtool-box-textbox">
        <div class="mtool-box-text1">点击拨打电话</div>
        <div class="mtool-box-text2">获得一对一专业解答</div>
      </div>
    </a>
    <a href="tel:17762272502" class="mtools" v-if="flag && !animationFlags">
        <i style="color: #fff;" :class="(flags ?'animate__animated animate__rubberBand ' : '') + 'el-icon-phone'"></i>
    </a> -->
  </div>
</template>

<script>
import Top from './components/newPage/Top.vue'
export default {
  name: 'App',
  components: {Top},
  data() {
    return {
      flag: false,
      flags: false,
      animationFlag: true,
      animationFlags: true
    }
  },
  mounted() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    this.flag = flag
    setInterval(() => {
      this.flags =!this.flags
    },4000)
    setTimeout(() => {
      this.animationFlag = false
    },5000)
    setTimeout(() => {
      this.animationFlags = false
    },5700)
  }
}
</script>

<style>
	@import url("assets/css/reset.css");
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* min-width: 1440px; */
}
html::-webkit-scrollbar {
  display: none;
}
.fontDistance {
    line-height: 1.6;
}
.tool {
  position: fixed;
  right: 2px;
  top: 60.6%;
}
.QRcode {
  width: 170px;
}
/* .el-popover__reference-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */
.mtool {
  /* position: fixed;
  right: 15px;
  bottom: 100px; */
  width: 40px;
  height: 40px;
  background-color: #409EFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
  /* box-shadow: 0px 0px 10px rgba(0,0,0,0.3); */
}
.mtools {
  position: fixed;
  right: 15px;
  bottom: 100px;
  width: 50px;
  height: 50px;
  background-color: #409EFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
  /* box-shadow: 0px 0px 10px rgba(0,0,0,0.3); */
}
.mtool-box {
  position: fixed;
  right: 15px;
  bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 99999px;
  background-color: #fff;
  padding: 5px;
}
.mtool-box-text1 {
  font-size: 14px;
  color: #000;
}
.mtool-box-text2 {
  color: #adaaaa;
  font-size: 9px;
}
.mtool-box-textbox {
  margin: 0 10px
}
.actionsclass {
  animation: example 1s forwards;
}
@keyframes example {
  0% { right:15px;opacity: 1;}
  100% { right: -90px;display: none;opacity: 0; }
}
</style>



// WEBPACK FOOTER //
// src/App.vue